import { get, patch, post, remove } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface Member {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  role: "member" | "admin" | string;
  /** ACTIVE, or UNCONFIRMED (invited, no password yet) */
  status: string;
  createdAt: string;
  isYou: boolean;
}

export interface MemberInvitation {
  id: string;
  email: string | null;
  createdAt: string;
  expiresAt: string;
  expired: boolean;
}

export interface MembersOverview {
  organizationName: string;
  members: Member[];
  invitations: MemberInvitation[];
  seatLimit: number | null;
  seatsUsed: number;
}

export const getMembers = (): Promise<ApiResponse<MembersOverview>> =>
  get(`/members`, null);

export const inviteMember = (email: string): Promise<ApiResponse<void>> =>
  post(`/members/invitations`, { email }, null);

export const revokeMemberInvitation = (id: string): Promise<ApiResponse<void>> =>
  remove(`/members/invitations/${id}`, null);

export const resendMemberInvitation = (id: string): Promise<ApiResponse<void>> =>
  post(`/members/invitations/${id}/resend`, {}, null);

export const setMemberRole = (
  userId: string,
  role: "member" | "admin",
): Promise<ApiResponse<void>> => patch(`/members/${userId}`, { role }, null);

export const removeMember = (userId: string): Promise<ApiResponse<void>> =>
  remove(`/members/${userId}`, null);
